import { render } from "./hubPassIcon.svg?vue&type=template&id=78d5a5df"
const script = {}
script.render = render

export default script